import React, { useMemo, useState } from "react";
import {
    Card,
    Typography,
    Stack,
    CircularProgress,
    Box,
    Button,
    Avatar,
    Chip
} from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import { useNavigate } from "react-router-dom";
import EventPopup from "./EventPopup";
import dayjs from "dayjs";


const typeMap = {
    training: {
        label: "Szkolenie",
        color: "#1e6169",
    },
    vr: {
        label: "VR",
        color: "#43127b",
    }
};

const PastEventsCard = ({ report, loading = false }) => {
    const navigate = useNavigate();

    const [open, setOpen] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);


    const pastEvents = useMemo(() => {
        if (!report?.callendarEvents) return [];

        const now = new Date();


        return report.callendarEvents
            .filter((event) => event?.end && new Date(event.end) < now)
            .sort((a, b) => new Date(b.end) - new Date(a.end));
    }, [report]);

    return (
        <Card sx={{ mb: 3, p: 3, borderRadius: 3, boxShadow: 3 }}>
            <Typography variant="h6" mb={2} fontWeight={600}>
                {/* Wydarzenia, w których brało udział twoje dziecko */}
                Wydarzenia, które były zaplanowane dla twojego dziecka
            </Typography>

            {loading && (
                <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
                    <CircularProgress />
                </Box>
            )}

            {!loading && pastEvents.length === 0 && (
                <Typography color="text.secondary">
                    Brak dostępnych wydarzeń
                </Typography>
            )}

            {!loading && pastEvents.length > 0 && (
                <Stack spacing={2}>
                    {pastEvents.map((event) => {
                        const eventDate = new Date(event.start);
                        const eventDateEnd = new Date(event.end);

                        return (
                            <>
                                <Card
                                    key={event.id}
                                    sx={{
                                        p: 2,
                                        borderRadius: 2,
                                        display: "flex",
                                        alignItems: "flex-start",
                                        gap: 2,
                                        background: "#f9fafb",
                                        boxShadow: 1,
                                        transition: "0.2s",
                                        "&:hover": {
                                            boxShadow: 4,
                                        },
                                    }}
                                >
                                    <Avatar
                                        sx={{ bgcolor: "#294e6b", width: 40, height: 40, mt: 0.5 }}
                                    >
                                        <EventIcon />
                                    </Avatar>

                                    <Box sx={{ flex: 1 }}>
                                        <Typography fontWeight={600}>
                                            {event.title || "Bez nazwy wydarzenia"}
                                            {"  "}
                                            {event.meta?.type && (
                                                // <Chip
                                                //     label={`${typeMap[event.meta.type]?.label || event.meta.type}`}
                                                //     // color={typeMap[event.meta.type]?.color || "default"}
                                                //     sx={{
                                                //         backgroundColor:
                                                //             typeMap[event.meta.type]?.color || "#777",
                                                //         color: "#fff",
                                                //         "& .MuiChip-label": {
                                                //             color: "#fff",
                                                //             fontWeight: 500,
                                                //         },
                                                //     }}
                                                //     size="small"
                                                // />

                                                <Box
                                                    sx={{
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        px: 1,
                                                        py: 0.3,
                                                        borderRadius: "16px",
                                                        backgroundColor: typeMap[event.meta.type]?.color || "#777",
                                                        color: "#fff",
                                                        fontSize: "0.75rem",
                                                        fontWeight: 500,
                                                    }}
                                                >
                                                    {typeMap[event.meta.type]?.label || event.meta.type}
                                                </Box>
                                            )}
                                        </Typography>

                                        <Typography
                                            variant="body2"
                                            color="text.secondary"
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 0.5,
                                                mt: 0.5,
                                            }}
                                        >
                                            <EventIcon sx={{ fontSize: 16, color: "#294e6b" }} />
                                            {/* {eventDate.toLocaleString("pl-PL")} */}
                                            {dayjs(eventDate).format('DD.MM.YYYY HH:mm')} - {dayjs(eventDateEnd).format('DD.MM.YYYY HH:mm')}
                                        </Typography>

                                        {event.meta?.description && (
                                            <Typography variant="body2" sx={{ mt: 1 }}>
                                                {event.meta?.description}
                                            </Typography>
                                        )}

                                        <Box sx={{ mt: 1 }}>
                                            <Button
                                                size="small"
                                                variant="outlined"
                                                onClick={() => setSelectedEvent(event)}
                                            >
                                                Szczegóły
                                            </Button>
                                        </Box>
                                    </Box>
                                </Card>


                            </>
                        );
                    })}
                </Stack>
            )}
            <EventPopup
                open={!!selectedEvent}
                onClose={() => setSelectedEvent(null)}
                event={selectedEvent}
            />
        </Card>
    );
};

export default PastEventsCard;